import Vue from 'vue';
import VueRouter from 'vue-router';

import AnaliseView from '@/views/analise/AnaliseView.vue';
import CadastrarRegiao from '@/views/regiaoAnalise/CadastrarRegiao.vue';
import PaginaInicial from '@/views/paginaInicial/PaginaInicial.vue';
import CaixaEntrada from '@/views/caixaEntrada/CaixaEntrada.vue';
import TipoDocumento from '@/views/tipoDocumento/TipoDocumento.vue';
import TermoCompromissoValidacao from '@/views/termoCompromisso/TermoCompromissoValidacao.vue';
import RegiaoAnalise from '@/views/regiaoAnalise/RegiaoAnalise.vue';
import AssinaturaTermoCompromisso from '@/views/assinatura/AssinaturaTermoCompromisso.vue';
import SolicitacaoToken from '../views/solicitarToken/SolicitacaoToken.vue';
import AnaliseHistorico from '../views/analiseHistorico/AnaliseHistorico.vue';
import MigracaoProcesso from '../views/migracaoProcesso/MigracaoProcesso.vue';
import AnaliseVinculo from '@/views/analiseVinculo/analise.vue';
import { Perfil } from '@/utils/constants.utils.js';
import MonitoramentoPrada from '../views/monitoramento/MonitoramentoPrada.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/regiao',
        name: 'regiao',
        component: RegiaoAnalise,
        meta: { perfis: [Perfil.ADMINISTRADOR_ANALISE], titulo: 'Regiões de analise' },
    },
    {
        path: '/regiao/:id?',
        name: 'regiao-cadastrar',
        component: CadastrarRegiao,
        meta: { perfis: [Perfil.ADMINISTRADOR_ANALISE], titulo: 'Regiões de analise' },
    },
    {
        path: '/pagina-inicial',
        name: 'pagina-inicial',
        component: PaginaInicial,
        meta: {
            perfis: [Perfil.GERENTE_OPERACIONAL],
            titulo: 'Página Inicial',
            codigo: 'PAGINA_INICIAL_GO',
            mostrarFaseProcesso: true,
        },
    },
    {
        path: '/caixa-entrada',
        name: 'caixa-entrada',
        component: CaixaEntrada,
        meta: {
            perfis: [Perfil.GERENTE_OPERACIONAL],
            titulo: 'Caixa de entrada',
            codigo: 'CAIXA_ENTRADA_GO',
            mostrarFaseProcesso: true,
        },
    },
    {
        path: '/analise-vinculo',
        name: 'analise-vinculo',
        component: AnaliseVinculo,
        meta: {
            perfis: [Perfil.GERENTE_OPERACIONAL],
            titulo: 'Análise',
            codigo: 'ANALISE_VINCULO',
            mostrarFaseProcesso: true,
        },
    },
    {
        path: '/tipo-documento',
        name: 'tipo-documento',
        component: TipoDocumento,
        meta: { perfis: [Perfil.ADMINISTRADOR_ANALISE], titulo: 'Tipos de Documentos', codigo: 'TIPO_DOC' },
    },
    {
        path: '/novomenu',
        name: 'Etapa Criada',
        component: CaixaEntrada,
        meta: { perfis: [Perfil.GERENTE_OPERACIONAL], titulo: 'Novo Menu', codigo: 'CAIXA_ENTRADA_GO' },
    },
    {
        path: '/analise-proposta',
        name: 'analise-proposta',
        component: CaixaEntrada,
        meta: { perfis: [Perfil.TECNICO], titulo: 'Análise da Proposta', codigo: 'ANALISE_PROPOSTA' },
    },
    {
        path: '/analise-proposta/:id',
        name: 'analise',
        component: AnaliseView,
        meta: { perfis: [Perfil.TECNICO, Perfil.GERENTE_OPERACIONAL] },
    },
    {
        path: '/validacao-proposta',
        name: 'validacao-proposta',
        component: CaixaEntrada,
        meta: { perfis: [Perfil.GERENTE_OPERACIONAL], titulo: 'Validação da Proposta', codigo: 'VALIDACAO_PROPOSTA' },
    },
    {
        path: '/termo-compromisso',
        name: 'termo-compromisso',
        component: CaixaEntrada,
        meta: { perfis: [Perfil.GERENTE_OPERACIONAL], titulo: 'Termo de Compromisso', codigo: 'TERMO_COMPROMISSO' },
    },
    {
        path: '/consultar-processos',
        name: 'consultar-processos',
        component: CaixaEntrada,
        meta: {
            perfis: [Perfil.TECNICO, Perfil.GERENTE_OPERACIONAL, Perfil.SEMIL],
            titulo: 'Consultar processos',
            codigo: 'CONSULTAR_PROCESSOS',
        },
    },
    {
        path: '/validacao-termo-compromisso',
        name: 'validacao-tc',
        component: TermoCompromissoValidacao,
        meta: {
            perfis: [Perfil.GERENTE_OPERACIONAL, Perfil.TECNICO, Perfil.PUBLICO],
            titulo: 'Validar termo compromisso',
            codigo: 'VALIDACAO_TERMO_COMPROMISSO',
        },
    },
    {
        path: '/reanalise-proposta',
        name: 'reanalise-proposta',
        component: CaixaEntrada,
        meta: { perfis: [Perfil.TECNICO], titulo: 'Em Reanálise', codigo: 'REANALISE_PROPOSTA' },
    },
    {
        path: '/assinar-termo',
        name: 'assinar-termo',
        component: AssinaturaTermoCompromisso,
        meta: { perfis: [Perfil.USUARIO_EXTERNO], titulo: '', codigo: 'USUARIO_EXTERNO' },
    },
    {
        path: '/solicitacao-token',
        name: 'solicitacao-token',
        component: SolicitacaoToken,
        meta: { perfis: [Perfil.USUARIO_EXTERNO], titulo: '', codigo: 'SOLICITACAO_TOKEN' },
    },
    {
        path: '/analise-historico/:idProcesso',
        name: 'analise-historico',
        component: AnaliseHistorico,
        meta: {
            perfis: [Perfil.TECNICO, Perfil.GERENTE_OPERACIONAL],
            titulo: 'Historico da Análise',
            codigo: 'ANALISE_HISTORICO',
        },
    },
    {
        path: '/migracao-processos',
        name: 'migracao-processos',
        component: MigracaoProcesso,
        meta: { perfis: [Perfil.ADMINISTRADOR_ANALISE], titulo: 'Migração de Processos', codigo: 'MIGRACAO_PROCESSOS' },
    },
    {
        path: '/monitoramento-prada',
        name: 'monitoramento-prada',
        component: MonitoramentoPrada,
        meta: {
            perfis: [Perfil.TECNICO, Perfil.GERENTE_OPERACIONAL],
            titulo: 'Monitoramento Prada',
            codigo: 'MONITORAMENTO_PRADA',
        },
    },
];

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes,
});

export default router;
